import { cn } from "@/lib/utils";

interface BrandLogoProps {
  className?: string;
  iconClassName?: string;
  iconOnly?: boolean;
  inverted?: boolean;
  size?: "sm" | "md" | "lg";
  textClassName?: string;
}

const sizeClasses = {
  sm: {
    icon: "h-8 w-8",
    text: "text-xl",
    gap: "gap-2.5",
  },
  md: {
    icon: "h-10 w-10",
    text: "text-2xl",
    gap: "gap-3",
  },
  lg: {
    icon: "h-12 w-12",
    text: "text-[2rem]",
    gap: "gap-3.5",
  },
} as const;

export function BrandLogo({
  className,
  iconClassName,
  iconOnly = false,
  inverted = false,
  size = "md",
  textClassName,
}: BrandLogoProps) {
  const currentSize = sizeClasses[size];
  const wordmarkColor = inverted ? "text-white" : "text-[#26215C] dark:text-[#F8F7FF]";

  return (
    <div className={cn("inline-flex items-center", currentSize.gap, className)}>
      <svg
        viewBox="0 0 72 72"
        fill="none"
        aria-hidden="true"
        className={cn(currentSize.icon, iconClassName)}
      >
        <rect x="4" y="4" width="64" height="64" rx="20" fill="#4A42A8" />
        <rect x="18" y="34" width="8" height="18" rx="4" fill="#6B63CC" />
        <rect x="32" y="24" width="8" height="28" rx="4" fill="#8B80E8" />
        <rect x="46" y="16" width="8" height="36" rx="4" fill="#6B63CC" />
        <path
          d="M22 33C24.4 22.5 33.1 15 43 15C47.7 15 52.1 16.6 55.7 19.5"
          stroke="#E8C97A"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      {iconOnly ? null : (
        <span
          className={cn(
            "font-medium leading-none tracking-[-0.5px]",
            currentSize.text,
            wordmarkColor,
            textClassName,
          )}
        >
          Arqum
        </span>
      )}
    </div>
  );
}
